import React, { FC } from 'react';
import styled from 'styled-components';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Text } from 'components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { colors } from 'styles/colors';
import { CustomIcon } from 'components/custom-icon/CustomIcon';
import { PHONE_WHITE_SVG } from 'assets/icons/icons';
import { bodyFontSize, highlightedBodyFontSize } from 'src/pages-all/home/home.page.const';

const ContactBoxContainer = styled.div<{ minTablet: boolean; maxMobileLarge: boolean }>`
  border-radius: 10px;
  border: 1px solid ${colors.gray10};
  background-color: ${colors.white};
  padding: 30px;
  margin: ${({ maxMobileLarge }) => (maxMobileLarge ? '40px 0' : '40px auto')};
  width: ${({ maxMobileLarge }) => (maxMobileLarge ? '100%' : '85%')};
  display: ${({ minTablet }) => (minTablet ? 'flex' : 'block')};
  flex-wrap: wrap;
`;

const ContectItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
`;

const PhoneBox = styled.div<{ tablet: boolean }>`
  padding: 10px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.primary};
  margin-bottom: 8px;
  margin-top: ${({ tablet }) => (tablet ? '0' : '30px')};
`;

const EmailBox = styled.div<{ tablet: boolean }>`
  padding: 10px;
  border-radius: 10px;
  border-color: ${colors.primary};
  border: 1px solid ${colors.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin-top: 8px;
`;

export const ContactBox: FC = () => {
  const { minTablet, maxMobileLarge, minDesktop } = useBreakpoints();

  return (
    <ContactBoxContainer minTablet={minTablet} maxMobileLarge={maxMobileLarge}>
      <ContectItem style={{ flex: minTablet && !minDesktop ? '1' : '1.5', textAlign: maxMobileLarge ? 'center' : 'left' }}>
        {translate(translationKeys.homepage.faq.contact.info)
          .split('\n')
          .map((line, idx) => (
            <Text fontWeight={600} size={highlightedBodyFontSize(maxMobileLarge)} key={idx}>
              {line}
            </Text>
          ))}
      </ContectItem>
      <ContectItem style={{ flex: '1', margin: minTablet ? '0 0 0 24px' : '0' }}>
        <PhoneBox tablet={minTablet}>
          <CustomIcon
            src={PHONE_WHITE_SVG}
            width={18}
            height={18}
            color={colors.white}
            style={{ marginRight: '10px' }}
          />
          <Text fontWeight={600} size={bodyFontSize(maxMobileLarge)} color={'white'}>
            <a href="tel:+4962130089041" style={{ color: colors.white }}>
              +49 (0) 621 / 300 89041
            </a>
          </Text>
        </PhoneBox>
        <Text
          fontWeight={600}
          size={bodyFontSize(maxMobileLarge)}
          color={'blueGray'}
          style={{ textAlign: 'center', lineHeight: 1.2 }}
        >
          {translate(translationKeys.homepage.faq.contact.reachability)
            .split('\n')
            .map((line, i) => (
              <span key={i} style={{ display: 'block' }}>
                {line}
              </span>
            ))}
        </Text>
        <EmailBox tablet={minTablet}>
          <Text fontWeight={600} size={bodyFontSize(maxMobileLarge)} color={'primary'}>
            <a href="mailto:support@tutorspace.de">support@tutorspace.de</a>
          </Text>
        </EmailBox>
      </ContectItem>
    </ContactBoxContainer>
  );
};
